var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',[_c('h2',[_vm._v(_vm._s(_vm.$t("profile.events.header")))]),_c('vca-card',{staticClass:"shadowed vca-center"},[_c('AccountEventAspTable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }